module.exports = __webpack_public_path__ + "media/images/download_form_box_bg-10c3d26874813115148e5a384aef74af.png";